import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
const components = [{
  title: 'Sistema 360 Lash',
  desc: '6 tomos estratégicos para ayudarte a ordenar la base de tu negocio: gestión y estructura, costos y precios, comunicación y ventas por WhatsApp, posicionamiento profesional, experiencia de clienta y orden y crecimiento.',
  isBase: true
}, {
  title: 'Bono 1 — Pack de Scripts WhatsApp',
  desc: 'Mensajes listos para responder consultas, enviar condiciones, cerrar reservas y comunicarte con más claridad.'
}, {
  title: 'Bono 2 — Fichero Técnico de Clientas',
  desc: 'Una herramienta para registrar información clave, seguimiento y detalles importantes de cada servicio.'
}, {
  title: 'Bono 3 — Checklist Operativo Diario',
  desc: 'Tu guía práctica para mantener orden antes, durante y después de cada jornada.'
}, {
  title: 'Bono 4 — Kit de Políticas Profesionales',
  desc: 'Textos y estructura para comunicar señas, cancelaciones, horarios, llegadas tarde y condiciones del servicio.'
}, {
  title: 'Bono 5 — Planner Semanal de Control del Negocio',
  desc: 'Una vista simple para organizar tareas, turnos, prioridades y seguimiento semanal.'
}, {
  title: 'Bono 6 — Pack de Hojas Manuales para Costos y Precios',
  desc: 'Plantillas para ayudarte a calcular mejor y dejar de tomar decisiones a ojo.'
}, {
  title: 'Extra Premium — Acelerador Profesional',
  desc: 'Un recurso adicional para ayudarte a potenciar la parte comercial y acelerar la profesionalización de tu negocio.',
  isGift: true
}];
export function Solution() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-ocean-blue" data-id="element-176">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-178">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-179">
            La solución que estabas necesitando — un sistema listo para aplicar
          </h2>
          <p className="text-lg text-gray-600" data-id="element-180">
            Sistema 360 Lash no es un ebook genérico. Es un sistema práctico
            pensado para lashistas que quieren dejar de improvisar, ordenar su
            negocio y crecer con más estructura, claridad y control.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4" data-id="element-181">
          {components.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-4 md:items-center shadow-sm border ${item.isBase ? 'bg-ocean-teal text-white border-ocean-teal-dark' : item.isGift ? 'bg-ocean-gold-light border-ocean-gold/20' : 'bg-white border-gray-100'}`} data-id="element-182">
              <div className="flex-shrink-0" data-id="element-183">
                <CheckCircle2 className={`w-8 h-8 ${item.isBase ? 'text-white' : item.isGift ? 'text-ocean-gold-dark' : 'text-ocean-teal'}`} data-id="element-184" />
              </div>
              <div data-id="element-185">
                <h3 className={`text-xl font-bold mb-1 ${item.isBase ? 'text-white' : 'text-gray-900'}`} data-id="element-186">
                  {item.title}
                </h3>
                <p className={`${item.isBase ? 'text-ocean-teal-light' : 'text-gray-600'}`} data-id="element-187">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-188">
          <button onClick={scrollToOffer} className="inline-flex items-center gap-2 px-8 py-4 bg-white text-ocean-teal border-2 border-ocean-teal hover:bg-ocean-teal hover:text-white rounded-xl font-semibold text-lg transition-colors shadow-sm" data-id="element-189">
            VER OPCIONES DE COMPRA
            <ArrowRight className="w-5 h-5" data-id="element-190" />
          </button>
        </div>
      </div>
    </section>;
}